import { render } from "./Menu.vue?vue&type=template&id=ea983960&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=ea983960&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src383431102/src/serverlesspressoV3/frontends/vue-barista-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea983960"]])

export default __exports__